import { Component, EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { __usernameOrEmail } from '../../../directives/validators/sts-conditional-email-validator.directive';
import { StsTenant } from '../../../models/sts-tenant.model';
import { StsPortalStatus } from '../../../models/sts-portal-status';
import { StsA360RegServicesService } from '../../../services/sts-a360-reg-services.service';
import { StsNotificationType } from '../../../models/sts-notification-type';
import { ActivatedRoute, Router } from '@angular/router';
import { StsTfaRegServiceService } from '../../../services/sts-tfa-reg-service.service';
import { StsPortalStatusService } from '../../../services/sts-portal-status.service';
import { StsTenantService } from '../../../services/sts-tenant.service';
import { StsNotification } from '../../../models/sts-notification.model';
import { StsCmsService } from '../../../services/sts-cms-service.service';
import StsA360NotificationTokenModel from 'app/models/sts-a360-notification-token.model';

@Component({
  selector: 'app-account-reg-verify-otc',
  templateUrl: './account-reg-verify-otc.component.html',
  styleUrls: ['./account-reg-verify-otc.component.scss']
})
export class AccountRegVerifyOtcComponent implements OnInit {


  public errors: StsNotification[] = [];
  public triggerValidateEmitter: EventEmitter<void> = new EventEmitter<void>();
  public submitter: EventEmitter<boolean> = new EventEmitter<boolean>();
  public frmOtc: FormGroup;
  public tenantInfo: StsTenant = new StsTenant();
  public invalidCode = false;
  public tfaReference: string;
  public isRunOfAttempt: boolean;
  public counter: number;
  public id: string;
  message: StsA360NotificationTokenModel;

  constructor(private tfa: StsTfaRegServiceService,
    private regService: StsA360RegServicesService,
    private portalStatusService: StsPortalStatusService,
    private route: ActivatedRoute,
    private tenantService: StsTenantService,
    public fb: FormBuilder,
    private cmsService: StsCmsService,
    private router: Router) {

    this.route.params.subscribe(params => {
      this.id = params['id'];
    });

    this.tenantService.getTenantSource().subscribe(tenant => {
      this.tenantInfo = tenant;

      this.portalStatusService.getPortalStatus().subscribe(
        (portalStatus: StsPortalStatus) => {
          this.tfaReference = portalStatus.tfaReference;
        });

    });

    this.frmOtc = this.fb.group({
      trust: new FormControl(),
      code: new FormControl('',
        {
          validators: [Validators.required],
          updateOn: 'submit'
        })
    }, { updateOn: 'submit' });
  }

  ngOnInit() {
    this.regService.currentMessage.subscribe(message => this.message = message);
  }

  public triggerValidation(v) {
    this.frmOtc.controls['code'].updateValueAndValidity();
  }

  public gotoHome(): void {
    this.router.navigateByUrl('/');
  }

  isInvalidCode(): boolean {
    return this.frmOtc.controls['code'].invalid &&
      (this.frmOtc.controls['code'].dirty || this.frmOtc.controls['code'].touched);
  }

  onSubmitCode(): void {
    this.triggerValidation('');
    this.invalidCode = false;
    if (this.frmOtc.valid) {
      this.errors = [];
      this.submitter.emit(true);
      this.regService.validateOneTimeCode(this.id, this.tenantInfo.clientCode, this.frmOtc.controls['code'].value, this.tfaReference
      ).subscribe(a => {
        this.submitter.emit(false);
        //the pin was good
        if (a.success && a.info.otcVerified) {
          //this tenant has 2 channels
          if (this.tenantInfo.tfaDeliveryChannels.length > 1) {
            //this user has both phone and email on their profile
            if (this.message.Phone != null && this.message.PersonalEmail != null && this.message.Phone.length > 0 && this.message.PersonalEmail.length > 0) {
              let urlemail = '/account/confirm/email/' + a.info.id;
              this.router.navigateByUrl(urlemail);
              return;
            }
            //this user does not have no email nor phone on their profile
            if (!(this.message.Phone != null && this.message.Phone.length > 0)) {
              if (!(this.message.PersonalEmail != null && this.message.PersonalEmail.length > 0)) {
                let url1 = '/account/reg-step-2/' + a.info.id + '/false/false';
                this.router.navigateByUrl(url1);
                return;
              }
            }
            //this user has phone OR email on their profile
            //update default communication method:
            if (this.message.Phone != null && this.message.Phone.length > 0)
              this.message.PreferredChannel = "phone";
            else {
              this.message.PreferredChannel = this.tenantInfo.tfaPreferredMode;
            }
            this.regService.changeMessage(this.message);
            let urlemail = '/account/confirm/email/' + this.id;
            this.router.navigateByUrl(urlemail);
          }
          //this tenant has 1 channel - the email
          else {
            this.message.PreferredChannel = "email";
            this.regService.changeMessage(this.message);
            //user has email
            if (this.message.PersonalEmail != null && this.message.PersonalEmail.length > 0) {
              let urlemail = '/account/confirm/email/' + this.id;
              this.router.navigateByUrl(urlemail);
            }
            //user does not have email in their profile
            else {
              let url1 = '/account/reg-step-2/' + a.info.id + '/false/false';
              this.router.navigateByUrl(url1);
            }
          }
        }
        else {
          var code = 'sts-incorrect-one-time-code-errors';
          var msg = 'Incorrect One Time Code';
          if (a.errors != null && a.errors[0] != null && a.errors[0].indexOf('Code:') == 0) {
            code = 'sts-' + a.errors[0].substr(5) + '-errors';
            msg = a.errors[0].substr(5);
          }
          let e = new StsNotification();
          e.code = code;
          e.level = StsNotificationType.Error;
          this.cmsService.getText(e.code).subscribe(res => {
            e.description = res ? res : msg;
            this.errors = [e];
          });
        }
      });
    } else {
      let e = new StsNotification();
      e.code = 'sts-wrong-one-time-code-errors';
      e.level = StsNotificationType.Error;
      this.cmsService.getText(e.code).subscribe(res => {
        e.description = res ? res : 'One Time Code must contain at least one symbol';
        this.errors = [e];
      });
    }
  }

}
